// extracted by mini-css-extract-plugin
export default {"installableAppsIndex__container":"installableAppsIndex__container__IQtf_","navLinks":"navLinks__Fkzax","navLinks__contentBlock":"navLinks__contentBlock__NmOQa"};